import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { listarCampanhas } from '../../services/campanhaService';

// Usando parâmetros padrão do JavaScript em vez de defaultProps
const FormClasse = ({ onSubmit, classeInicial }) => {
  const [classe, setClasse] = useState({
    numero: '',
    descricao: '',
    campanhaId: '',
    ...(classeInicial || {})  // Usando fallback aqui
  });
  const [campanhas, setCampanhas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCampanhas = async () => {
      setLoading(true);
      try {
        const response = await listarCampanhas();
        console.log('Estrutura completa da resposta:', response);
        console.log('Campanhas:', response.campanhas);
        console.log('Primeira campanha:', response.campanhas[0]);
        
        const campanhasData = response?.campanhas || [];
        setCampanhas(campanhasData);
      } catch (error) {
        console.error('Erro ao buscar campanhas:', error);
        setError(error);
        setCampanhas([]);
      } finally {
        setLoading(false);
      }
    };
  
    fetchCampanhas();
  }, []);

  useEffect(() => {
    if (classeInicial && Object.keys(classeInicial).length > 0) {
      setClasse(prevClasse => ({
        ...prevClasse,
        ...classeInicial
      }));
    }
  }, [classeInicial]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setClasse(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const dadosParaEnviar = {
      ...classe,
      instituicaoId: 4
    };
    console.log('Dados sendo enviados:', dadosParaEnviar);
    onSubmit(dadosParaEnviar);
  };
  if (loading) {
    return <div>Carregando campanhas...</div>;
  }

  if (error) {
    return <div>Erro ao carregar campanhas. Por favor, tente novamente.</div>;
  }

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        fullWidth
        label="Número da Classe"
        name="numero"
        type="number"
        value={classe.numero ?? ''}
        onChange={handleChange}
        margin="normal"
        required
        inputProps={{ min: 1, max: 12 }}
      />
      <TextField
        fullWidth
        label="Descrição"
        name="descricao"
        value={classe.descricao ?? ''}
        onChange={handleChange}
        margin="normal"
      />
      <FormControl fullWidth margin="normal">
        <InputLabel>Campanha</InputLabel>
        <Select
          name="campanhaId"
          value={classe.campanhaId ?? ''}
          onChange={handleChange}
          required
        >
          {campanhas.map((campanha) => (
            <MenuItem key={campanha.id} value={campanha.id}>
              {campanha.nome}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button 
        type="submit" 
        variant="contained" 
        color="primary" 
        sx={{ mt: 2 }}
      >
        {classe.id ? 'Atualizar Classe' : 'Criar Classe'}
      </Button>
    </form>
  );
};

FormClasse.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  classeInicial: PropTypes.shape({
    id: PropTypes.number,
    numero: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    descricao: PropTypes.string,
    campanhaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

export default FormClasse;